import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Dialog from "../../../components/Dialog";
import HeaderTachModal from "./components/HeaderTachModal";
import { UserRole } from "../../../model/Enums/UserRoleEnum";
import {
    IBlobStorage,
    getAccountFromBlobUrl,
    getBlobStorageString,
    getSasTokenFromBlobUrl,
} from "../../../utils/BlobDownload";
import Features from "../../../model/dto/Features";
import {
    StyledDivActionViewTach,
    StyledPdfContainer,
} from "../../../styles/pages/Workflows/InformationTach";
import ButtonStyles from "../../../styles/components/ButtonStyles";

const CONTAINER_NAME = "tach-documents";
const { BtnPrimary } = ButtonStyles;

export interface Document {
    id: number;
    status: string;
    fileName: string;
    funcionalidadeId: UserRole;
    funcionalidade: Features;
    created: string;
    updated: string;
}

type IModal = {
    open: boolean;
    onClose?: () => void;
    url: string;
};

const ModalViewTach = ({ open, onClose, url }: IModal) => {
    const [blobContent, setBlobContent] = useState<Blob | undefined>();
    const location = useLocation();
    const pathLocation = location.pathname.split("/");

    const getFileName = (uri: string) => {
        if (!uri) return "";
        const uriSplit = uri.split("?")[0].split("/");
        return decodeURI(uriSplit[uriSplit.length - 1].replaceAll("%20", " "));
    };

    const getProcessUrl = async () => {
        setBlobContent(undefined);

        const blobParams: IBlobStorage = {
            account: getAccountFromBlobUrl(url),
            sas: getSasTokenFromBlobUrl(url),
            containerName: CONTAINER_NAME,
            blobName: getFileName(url),
        };

        const newBlobContent = await getBlobStorageString({
            ...blobParams,
        });

        setBlobContent(newBlobContent);
    };

    useEffect(() => {
        getProcessUrl();
    }, [pathLocation[1]]);

    const blob =
        blobContent && new Blob([blobContent], { type: "application/pdf" });
    const blobURL = blob && URL.createObjectURL(blob);

    return (
        <Dialog
            openModal={open}
            onHide={onClose}
            size="width-1000 modal-white modal-radius-8"
        >
            <HeaderTachModal
                title="Visualizar TACH"
                subtitle="Confira na imagem os detalhes do TACH selecionado."
            />
            {blobURL && (
                <StyledPdfContainer>
                    <embed
                        src={`${blobURL}#toolbar=0&navpanes=0`}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                    />
                </StyledPdfContainer>
            )}
            <StyledDivActionViewTach>
                <BtnPrimary onClick={onClose}>Voltar</BtnPrimary>
            </StyledDivActionViewTach>
        </Dialog>
    );
};

export default ModalViewTach;
